import { Footer as InternalFooter } from '@lessonnine/design-system.lib'
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem'
import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

const Footer = {
  [DS_VERSIONS.default]: InternalFooter,
}

export default Footer[CURRENT_DS_VERSION]
